class FetchError extends Error {
  constructor(msg, retryCallback, info) {
    super(msg);
    this.retry = retryCallback;
    this.info = info;
  }
}

export default FetchError;
